// Copyright (c) 2016 Deere & Company

import SelectedDealers, {getDefaultState as getSelectedDealersDefaultState} from './selected-dealers';
import ServiceIntervalStatuses, {getDefaultState as getServiceIntervalStatusesDefaultState} from './service-interval-statuses';
import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import {getDefaultState as getDateRangeDefaultState} from './date-range';
import t from 'tcomb';

const Criteria = t.struct({
    model: t.String,
    pin: t.String,
    planEndDate: DateRange,
    planName: t.String,
    planStartDate: DateRange,
    selectedDealers: SelectedDealers,
    serviceIntervalBeginDate: DateRange,
    serviceIntervalEndDate: DateRange,
    serviceIntervalStatuses: ServiceIntervalStatuses,
    serviceIntervalType: t.String
}, 'Criteria');

export const getDefaultState = () =>
    new Criteria({
        model: '',
        pin: '',
        planEndDate: getDateRangeDefaultState(),
        planName: '',
        planStartDate: getDateRangeDefaultState(),
        selectedDealers: getSelectedDealersDefaultState(),
        serviceIntervalBeginDate: getDateRangeDefaultState(),
        serviceIntervalEndDate: getDateRangeDefaultState(),
        serviceIntervalStatuses: getServiceIntervalStatusesDefaultState(),
        serviceIntervalType: ''
    });

export default Criteria;



// WEBPACK FOOTER //
// ./src/reports/maintenance-plan/state/criteria.js